<!--
 * @Author: weijinpeng jinpeng.wei@ctx.sg
 * @LastEditors: weijinpeng jinpeng.wei@ctx.sg
 * @Date: 2022-11-06 20:17:07
 * @LastEditTime: 2023-07-07 10:40:46
 * @Description: 
-->
<template>
   <div class="menu_logo" :class="!collapsed ? 'mg' : 'mg_t'">
        <div class="menu_logo_icon" :class="!collapsed ? '' : 'flex_c'">
            <!-- <img class="logo" src="@/assets/img/ac_log.png" alt="">
            <div class="shu" v-show="!collapsed"></div> -->
            <img class="logo1" v-show="!collapsed" src="@/assets/img/mvgx.png" alt="">
            <div class="shu" v-show="!collapsed"></div>
            <img class="logo2" :class="!collapsed ? '' : 'wid'"  src="@/assets/img/onelogo.png" alt="">
            <div class="txt" v-show="!collapsed">TÜV SÜD 核证</div>
        </div>
        <a-divider style="border-color: #00142a59"/>
   </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name:'layoutLogo',
    props:{
        collapsed:{
            required:true,
            type:Boolean
        }
    },
})
</script>
<style scoped lang='less'>
.mg{
    margin: 35px 15px 0 15px;
}
.mg_t{
    margin: 35px 0 0 0;
}
.flex_c{
    justify-content: center;
}
.menu_logo{
    .menu_logo_icon{
        display: flex;
        align-items: flex-end;
        // margin-left: 29px;
        justify-content: center;
        height: 35px;
        .shu{
            width: 1px;
            height: 22px;
            border: 1px solid rgba(0,20,42,0.35);
            margin: 0 7px;
        }
        .wid{
            width: 50px !important;
            height: 50px !important;
            transform: translateY(15px);
        }
        .logo{
            width:33px;
            height: 29px;
            // margin: 0 auto;
        }
        .logo1{
            width: 74px;
            height: 29px;
        }
        .logo2{
            width: 29px;
            height: 29px;
        }
        .txt{
            font-size: 12px;
            font-weight: normal;
            color: #FFFFFF;
            line-height: 14px;
        }
    }
    .ant-divider-horizontal{
        margin: 47px 0 8px 0;
    }
}
</style>